import { PDKEmptyValueIcon } from '@/components/ui/pdk-icons';
import { cn } from '@/lib/utils';
import type { Deal } from '@/models/registry';
import { Button } from '../../ui/button';
import { STATUS_OPTIONS_MAP } from './deal-status-selector';

export const DealStatusBadge = ({
  value,
  hideCopy = false,
  buttonRef,
  className,
  buttonVariant = 'ghost',
  additionalCopy,
}: {
  value: Deal['status'];
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
  buttonVariant?: 'outline' | 'ghost';
  additionalCopy?: string;
}) => {
  const option = STATUS_OPTIONS_MAP.find((option) => option.value === value);

  return (
    <Button
      variant={buttonVariant}
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      {value === null && (
        <>
          <PDKEmptyValueIcon className="h-3.5 w-3.5" />
          <p className="rounded text-xs  text-gray-600">No Status</p>
        </>
      )}
      {option?.icon}
      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600 flex flex-row gap-1">
          {STATUS_OPTIONS_MAP.find((option) => option.value === value)?.label}
          {additionalCopy && <span>👉</span>}
          {additionalCopy && <span>({additionalCopy})</span>}
        </p>
      )}
    </Button>
  );
};
